import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div style="text-align: justify;">
      <p class="mb-3 bold">
        I. MALBENO DE MALJUNECO
      </p>
      
      <p class="mb-3">
        Kiel kompreni tion? Ke maljuneco mem estas malbeno? 
        Aŭ ke maljuneco malbenas ĉion, kio ne estas maljuna, kio ne pretas forlasi la mondon?
      </p>
      
      <p class="mb-3">
        Bedaŭrinde, ambaŭ respondoj pravas.
      </p>
      
      <p class="mb-3">
        La maljuneco estas senkompata. Ĝi kripligas, ruinigas, senvirtigas homojn, forprenas de ili ĉion bonan, kion ili havis, kaj substrekas, 
        plifortigas, plikreskigas iliajn mankojn, montrante ilin en sarkasme trograndigita aspekto. 
        Kiu estis ŝparema – fariĝas abomene malavara; kiu sin nutris per infana pura kredo je Dio – fariĝas monstra fanatikulo. 
        La mensoj febliĝas, atrofiiĝas kapablo pensi racie kaj kritike. 
        Dum la longa vivo oni tiom da abomenaĵoj spertis, al tiom da ili oni devis alkutimiĝi, humiliĝi… 
        Kaj homo alkutimiĝas, rezignacias; nenio plu jam alvokas indignon aŭ repuŝon, la sentoj ekdormas kaj formortas. 
        La homo rigidiĝas en iu sia antaŭa stato: la plejmulto ĉesas disvolviĝi en la aĝo de 11 jaroj, ĉ. la fino de bazlernejo; preskaŭ ĉiuj – 
        ekde komenco aŭ ekstremokaze ekde fino de seksa maturiĝo, t.e. geedziĝo. Poste daŭras nur «ĝisvivado» – la moviĝo laŭ la samaj reloj ĝis la fino, 
        sen ajnaj ŝanĝoj de direkto, ĉu supren, ĉu flanken.
      </p>
      
      <p class="mb-3">
        Kaj nur unu sento kreskas konstante dum la tuta vivo kaj plene ekposedas la homon ĉe maljuneco – la <span class="bold">timo</span>. 
      </p>
      
      <p class="mb-3">
        La tutan vivon li devis ion timi, ion eviti, de io sin kaŝi; kaj tiu neceso fariĝis lia dua naturo, eniris lian karnon kaj sangon, plenposedas lin. 
        Ĉe maljuneco ĝi absolute dominas en lia vivo. 
        ĈIO estas danĝera; ĉio, kio minacas rompi aŭ iel formovi la ekzistantajn kradojn; sed ĉar la vivo mem estas ŝanĝo, do danĝeras ĉio! 
        La moviĝo de la vivo nature alpuŝas maljunulojn al abismo, al la fino: nenio jam restis kutima por vi, ne estas jam por vi la loko ĉi tie!
      </p>
      
      <p class="mb-3">
        Kaj iu obeeme foriras, pelata de tiu malbeno, kiam la tuta mondo forpremas lin. 
        Sed iu redirektas tiun malbenon kontraŭ la ĉirkaŭa mondo, en senespera malico penante kunpreni en proksimiĝantan neeston almenaŭ ion el tio, kio ankoraŭ vivas. 
        Sed frue aŭ malfrue, ĉu la homo faros aŭ ne faros ankoraŭ iom da malbono, la malbeno de maljuneco forportos ankaŭ lin. 
      </p>
      
      <p class="mb-1 text-center">
        «Ne evitos vi sorton kruelan,
      </p>
      
      <p class="mb-1 text-center">
        Kiun planas por vi la destin’.
      </p>
      
      <p class="mb-1 text-center">
        Sed aprezu vi rajton plej belan:
      </p>
      
      <p class="mb-4 text-center">
        Mem elekti la morton por si!»
      </p>

      
      <p class="mb-3 bold">
        II. GRACO DE MALJUNECO
      </p>

      <p class="mb-3">
        «Sed estas en la mond’ aliaj lokoj ja…». 
        Kelkaj procentoj de homoj evitas la komunan sorton kaj iras per tute alia vojo, evoluante la tutan vivon. 
        Ilia vivo ne estas rektaj horizontalaj reloj, sed alta vivanta arbo kun multaj branĉoj, sur kiuj vibras freŝaj verdaj folioj, sed la pinto strebas sor, 
        kaj kreskas, kreskas, dum daŭras vivo. 
        Ĝin karesas suno, birdoj kantas inter branĉaro, kaj malsupren ĝi ĵetas salubran ombron, kie eblas ripozi kaj renovigi la fortojn. 
      </p>

      <p class="mb-3">
        Kiom da homoj sin savas en tiu ombro! 
        Kiom da bonkoreco, saĝeco, kiom da scio pri la leĝoj de naturo kaj de homa vivo transdonis al ni maljunuloj! 
        Kiom da forto ricevis ni de ili, restintaj fortaj malgraŭ esingiĝo de kutimaj vivofortoj! 
        Kiom da infanoj ili subtenis kaj savis per sia saĝeco kaj bonkoreco, kiom da homoj memoras en komenco de sia vivo ne gepatrojn, 
        sed avinon aŭ avon, aŭ la Instruiston, kiu malfermis por ili la vojon en la vivo! «Lumilo de la vivo» – tiel diras mi pri tiuj maljunuloj, kiuj prilumis al mi, 
        eniranta en la mondon, la vastan, puran kaj helan vojon, kiun mi mem povus ne trovi, vagante en kaoso kaj krepuskoj de puberta periodo! 
        Ili dotis min per Graco. 
        Kaj mi preĝas, ke almenaŭ parton de tiu Graco mi povu transdoni pluen! 
      </p>

      <p class="mb-3">
        (En la verko estas cititaj poemoj de N. Gumilov en traduko de l’ aŭtoro)
      </p>

      


    </div>







    `
  )
}

const itemName = {
  esp: 'Malbeno de maljunuleco'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;